import PropTypes from 'prop-types';
import { SVG } from './SVG';
const IconArrowUpDown = (props) => {
  const { direction, style, color } = props;
  if (direction === 'up') {
    return (
      <SVG width="9" height="6" style={style} viewBox="0 0 9 6" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M7.5 4.28564L4.5 1.28564L1.5 4.28564"
          stroke={color ? color : '#4062BB'}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </SVG>
    );
  } else {
    return (
      <SVG width="9" height="6" style={style} viewBox="0 0 9 6" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M1.5 1.28564L4.5 4.28564L7.5 1.28564"
          stroke={color ? color : '#4062BB'}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </SVG>
    );
  }
};
IconArrowUpDown.propTypes = {
  color: PropTypes.string,
  direction: PropTypes.string,
  style: PropTypes.object,
};
export { IconArrowUpDown as default, IconArrowUpDown };
